import React from 'react';
import { Spin, Typography } from 'antd';
import { useSelector } from 'react-redux';

import { QUERY_PARAM_KEYS } from '../../constants/massOfferings/queryParamKeys';
import { useSearchParams } from '../../hooks/useSearchParams';
import { useInitFeathery } from '../RecurringDonationQuestionnaire/useInitFeathery';
import selectors from '../../store/selectors';
import { Footer } from '../Layout';

const RecurringDonationQuestionnaireLazy = React.lazy(() =>
  import('../RecurringDonationQuestionnaire/RecurringDonationQuestionnaire'),
);

const DonateConfirmation = () => {
  const urlSearchParams = useSearchParams();
  const userEmail = urlSearchParams.get(QUERY_PARAM_KEYS.user);
  const parishData = useSelector(selectors.getAccountData);

  const { initDone, featheryFormName } = useInitFeathery(userEmail);

  return (
    <>
      <main className="container-lg flex-grow-1 flex-shrink-0 d-flex flex-column mt-5 justify-content-center">
        <div className="container-lg px-lg-0 h-100 d-flex flex-column justify-content-center mx-a">
          <div className="text-center">
            <Typography.Title level={userEmail ? 4 : 3} id="donate-message">
              Serdeczne Bóg zapłać za Twoją ofiarę.
              <br />
              Zapewniamy o&nbsp;modlitwie.
            </Typography.Title>

            <div>
              <Typography.Text>{parishData.donationSuccessPageAdditionalText}</Typography.Text>
            </div>
            <div>
              <Typography.Text>
                Potwierdzenie płatności otrzymasz od operatora w&nbsp;wiadomości email.
              </Typography.Text>
            </div>

            {userEmail && (
              <div>
                <React.Suspense fallback={<Spin />}>
                  <RecurringDonationQuestionnaireLazy
                    initialValues={{
                      CyklicznaOfiaraOnline_Hash: userEmail,
                    }}
                    formName={featheryFormName}
                    initDone={initDone}
                  />
                </React.Suspense>
              </div>
            )}
          </div>
        </div>
      </main>

      <Footer isWhite />
    </>
  );
};

export default DonateConfirmation;
